import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const StationaryBanners = () => {

    const servicesFaqData = [
        {
            question: "What are stationary banners, and where are they used?",
            answer: "Stationary banners are fixed display banners commonly used in retail spaces, exhibitions, and events. Printing of stationary banners is ideal for showcasing promotions, branding, and product information in a professional and eye-catching manner."
        },
        {
            question: "What materials are used for stationary banners printing?",
            answer: "We use high-quality vinyl and flex materials for stationary banners printing, ensuring durability and long-lasting visuals. These materials are ideal for both indoor and outdoor use, offering fade-resistant and weatherproof results."
        },
        {
            question: "Can Printingy handle bulk orders for stationary banners?",
            answer: "Yes, Printingy specialises in bulk printing of stationary banners. Our efficient processes ensure consistent quality, competitive pricing, and quick turnaround times for large-scale orders."
        },
        {
            question: "What customisation options are available for stationary banners?",
            answer: "Printingy provides a variety of customisation options, including sizes, colours, graphics, and finishes. Our design stationery banner printing services allow businesses to add logos, messaging, and unique visuals that align with their branding goals."
        },
        {
            question: "How does flex banner printing differ from other banner types?",
            answer: "Flex banner printing uses a flexible and durable material that delivers sharp visuals and vibrant colours. It is lightweight, weather-resistant, and ideal for stationary displays in both indoor and outdoor environments."
        },
        {
            question: "What industries benefit from stationary banners printing?",
            answer: "Stationary banners are widely used in industries such as retail, education, real estate, hospitality, and corporate events. Businesses rely on stationary banners printing to promote products, services, and brand messaging effectively."
        },
        {
            question: "How long does it take to print bulk stationary banners?",
            answer: "The turnaround time for printing of stationary banners depends on the order volume and design complexity. Standard bulk orders are typically completed within a few business days, with expedited services available for urgent requests."
        },
        {
            question: "Do you offer design assistance for stationary banners?",
            answer: "Yes, our design stationery banner printing services include professional design support. Whether you need help with layouts, logos, or messaging, our team ensures visually appealing banners tailored to your requirements."
        },
        {
            question: "Are stationary banners suitable for outdoor use?",
            answer: "Yes, our flex banner printing services use weatherproof materials, making stationary banners suitable for outdoor conditions like sunlight, wind, and light rain while maintaining their visual appeal."
        },
        {
            question: "What makes bulk stationary banner printing cost-effective?",
            answer: "Bulk stationary banners printing reduces per-unit costs, providing businesses with an economical solution for large-scale promotions. Printingy ensures high-quality printing at competitive pricing, delivering excellent value."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Stationary Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Stationary Banners Printing Services for Businesses"
  description="Professional printing of stationary banners with premium quality. Bulk stationary banners printing, flex banner printing, and design stationery banner printing for promotions."
  keywords="Printing of Stationary Banners,
Stationary Banners Printing,
Design Stationery Banner Printing,
Flex Banner Printing

"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Stationary Banners</h1>
              <h2 className="text-muted">
              Custom stationary banners printing for events, retail, and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Stationary banners are the perfect tool for creating impactful visual displays in events, retail spaces, and promotional campaigns. Printingy specialises in Printing of Stationary Banners, offering premium stationary banners printing services with sharp visuals, vibrant colours, and professional finishes.</p>
          <p>Our design stationery banner printing services ensure customised solutions to reflect your branding. From high-quality flex banner printing to tailored layouts, our stationary banners are durable, long-lasting, and ideal for both indoor and outdoor applications.</p>
          <p>Whether for product promotions, exhibitions, or business branding, Printingy delivers cost-effective bulk printing solutions to meet your needs with precision and consistency.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Custom Stationary Banner Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and visually impactful banners for promotions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of stationary banners for retail, events, and campaigns.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional stationary banners printing with vibrant graphics and durable materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored design stationery banner printing to align with your branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Premium flex banner printing for indoor and outdoor displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for precise, fade-resistant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Cost-effective solutions for large-scale promotions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, event organisers, and marketing professionals.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/stationaryprints.jpg" // Path relative to the public folder
                  alt="Design stationery banner printing solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Stationary Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your promotions while we manage your banner printing needs</h3>
            <p>At Printingy, we use advanced printing technology and high-quality materials to deliver exceptional stationary banners printing solutions. Whether for corporate events, retail branding, or advertising campaigns, our design stationery banner printing guarantees professional, durable results.</p>
            <p>With efficient production processes, we ensure timely delivery for bulk orders without compromising on quality. Partner with Printingy for stationary banners that capture attention and elevate your branding.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default StationaryBanners;
